import { render } from "./Asegurador_Tarifario.vue?vue&type=template&id=d2a982bc"
import script from "./Asegurador_Tarifario.vue?vue&type=script&lang=js"
export * from "./Asegurador_Tarifario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__